import { render, staticRenderFns } from "./HiqFooter.vue?vue&type=template&id=3a755f66&scoped=true&"
import script from "./HiqFooter.vue?vue&type=script&lang=js&"
export * from "./HiqFooter.vue?vue&type=script&lang=js&"
import style0 from "./HiqFooter.vue?vue&type=style&index=0&id=3a755f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a755f66",
  null
  
)

export default component.exports